module.exports = __webpack_public_path__ + "assets/img/home.c984e6e8.jpg";